import { Case } from './types'

// Helper to generate dates relative to today
const getRelativeDate = (daysAgo: number, hoursAgo: number = 0) => {
  const date = new Date()
  date.setDate(date.getDate() - daysAgo)
  date.setHours(date.getHours() - hoursAgo)
  return date.toISOString()
}

export const MOCK_CASES: Case[] = [
  {
    id: 'case-001',
    subject: 'Loan Application Issue - Missing Documents',
    description:
      'Borrower uploaded the wrong W-2 forms for 2023. Need to request the correct documents before underwriting can proceed. This has been pending for 3 days.',
    createdOn: getRelativeDate(45, 2),
    deletedOn: getRelativeDate(2, 4),
    ownedBy: 'Sarah Mitchell',
    deletedBy: 'Admin User',
  },
  {
    id: 'case-002',
    subject: 'Rate Lock Extension Request',
    description:
      'Client is requesting a 15-day extension on their rate lock due to delays in the appraisal process. Need manager approval.',
    createdOn: getRelativeDate(30, 5),
    deletedOn: getRelativeDate(1, 1),
    ownedBy: 'James Rodriguez',
    deletedBy: 'Sarah Mitchell',
  },
  {
    id: 'case-003',
    subject: 'Appraisal Dispute - 123 Oak Street',
    description:
      'Borrower is disputing the recent appraisal value, claiming it does not account for recent kitchen renovations. Re-evaluation requested.',
    createdOn: getRelativeDate(60, 10),
    deletedOn: getRelativeDate(5, 8),
    ownedBy: 'Emily Chen',
    deletedBy: 'System Cleanup',
  },
  {
    id: 'case-004',
    subject: 'Closing Delay - Title Search',
    description:
      'Title company found an old lien on the property that needs to be cleared before we can schedule closing. Reached out to seller agent.',
    createdOn: getRelativeDate(20, 1),
    deletedOn: getRelativeDate(0, 5), // Today, 5 hours ago
    ownedBy: 'Michael Torres',
    deletedBy: 'James Rodriguez',
  },
  {
    id: 'case-005',
    subject: 'Borrower Income Verification',
    description:
      'Unable to verify employment with the provided HR contact. Need alternative contact information or recent pay stubs.',
    createdOn: getRelativeDate(15, 3),
    deletedOn: getRelativeDate(7, 2),
    ownedBy: 'Lisa Park',
    deletedBy: 'Admin User',
  },
  {
    id: 'case-006',
    subject: 'Underwriting Exception Request',
    description:
      'Requesting exception for DTI ratio which is slightly above guidelines due to recent student loan consolidation.',
    createdOn: getRelativeDate(10, 6),
    deletedOn: getRelativeDate(3, 12),
    ownedBy: 'David Kim',
    deletedBy: 'System Cleanup',
  },
  {
    id: 'case-007',
    subject: 'Property Insurance Lapse Notice',
    description:
      'Received notice that the hazard insurance policy for the subject property will lapse next week. Need updated dec page.',
    createdOn: getRelativeDate(8, 4),
    deletedOn: getRelativeDate(1, 2),
    ownedBy: 'Rachel Adams',
    deletedBy: 'Sarah Mitchell',
  },
  {
    id: 'case-008',
    subject: 'Credit Report Discrepancy',
    description:
      'Borrower claims a recent late payment on their credit report is an error and has provided documentation from the creditor.',
    createdOn: getRelativeDate(5, 9),
    deletedOn: getRelativeDate(0, 1), // Today, 1 hour ago
    ownedBy: 'Support Queue',
    deletedBy: 'Admin User',
  },
]
